<template>
  <div v-show="empty" class="empty">
    <img :src="img" alt="" />
    <span style="color: #c0c0c0; font-size: 0.6rem"> 暂无数据 </span>
  </div>
</template>

<script>
export default {
  // 是否需要展示
  props: ["empty"],
  data() {
    return {
      img: require("../assets/empty/empty.png"),
    };
  },
};
</script>

<style lang="less" scoped>
.empty {
  width: 90%;
  margin: 0.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
  }
}
</style>
